import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { Image, Icon } from 'components/atoms'

const width = 80

const SliderCell = memo(({ value }) => (
  <Cell>
    <ImageWrapper>
      <ImageWrapper.Overlay>
        <Icon icon="fal fa-image" color="#FFF" />
      </ImageWrapper.Overlay>
      {value && typeof value === 'string' && <Image src={value} width={width} />}
    </ImageWrapper>
  </Cell>
))

const Cell = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const ImageWrapper = styled.div`
  position: relative;
  width: ${width}px;
  height: calc(${width}px * 9 / 16);
  overflow: hidden;
  background-color: ${props => props.theme.colors.grey};
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
  }
`;

ImageWrapper.Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
`

SliderCell.propTypes = {
  value: PropTypes.string.isRequired,
  original: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired
}

SliderCell.whyDidYouRender = true

export default SliderCell
